
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/ultimo-antojo",
      function () {
        return require("private-next-pages/checkout/ultimo-antojo/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkout/ultimo-antojo"])
      });
    }
  